// types
import type { AdditionalSelectors } from '../types';

// store
import * as actionCreators from './actionCreators';
import { MiddlewareManager } from './middlewareManager';
import { Selectors } from './selectors';

export const dealershipPickerCreators = actionCreators;
export let dealershipSelectors: Selectors;
export let middlewareMgr: MiddlewareManager;

export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors
): {
    selectors: Selectors;
    middlewareMgr: MiddlewareManager;
} => {
    dealershipSelectors = new Selectors(appName, additionalSelectors);
    middlewareMgr = new MiddlewareManager(dealershipSelectors);

    return {
        selectors: dealershipSelectors,
        middlewareMgr
    };
};
